import { render, staticRenderFns } from "./TiersSelector.vue?vue&type=template&id=ae0d5b06&"
import script from "./TiersSelector.vue?vue&type=script&lang=js&"
export * from "./TiersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports